import React, { useContext } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { RendererContext } from '../FURenderkit'
import FUIcon from '../Common/FUIcon'
import { Divider } from 'antd-mobile'
import { NAVIGATOR } from '@/App'

const searchCompName = (key) => {
    const arr = NAVIGATOR.reduce((prev, section) => {
        prev.push(...section.children)
        return prev
    }, [] as {
        key: string;
        title: string;
        icon: JSX.Element;
        description: string;
    }[])
    return <span className='renderkit-header-title'>
        {arr.find(item => item.key === key)?.title}
    </span>
}
const EmptyRoute = () => {
    const { comp } = useContext(RendererContext)
    const navigate = useNavigate()
    return (
        <>
            <header className='renderkit-header'>
                <FUIcon
                    name="slices/icon_forword_nor.png"
                    size="48px"
                    onClick={() => {
                        navigate(process.env.REACT_APP_HOMEPAGE as string)
                    }}
                >
                </FUIcon>
                <Divider className='renderkit-header-divider' direction='vertical' />
                {searchCompName(comp)}
            </header>
            <Outlet />
        </>
    )
}

export default EmptyRoute
